<template>
  <div class="vmodules">
    <label class="label" :class="{ 'label--settings': is_settings_page }">{{
      label
    }}</label>
    <div class="vmodules_list">
      <div v-for="item in modules" :key="item.id" class="vmodule">
        <div class="vmodule_name">
          {{ item.name || item.id }}
          <span v-if="item.is_new" class="new">NEW</span>
        </div>

        <switcher
          v-if="type === 'company' && item.is_enabled"
          v-tooltip="tooltip_options(item.is_active_by_default)"
          :value="item.is_active_by_default"
          @input="handleInput($event, item.id)"
        />
        <switcher
          v-if="type === 'vacancy'"
          :value="item.is_active"
          @input="handleInput($event, item.id)"
        />
        <switcher
          v-if="type === 'global'"
          :value="item.is_enabled"
          :disabled="item.is_disabled"
          @input="handleInput($event, item.id)"
        />

        <button
          v-if="!item.is_enabled && type === 'available'"
          class="vcv-button transparent"
          @click="$emit('requestPayment', item.id)"
        >
          {{
            item.is_requested
              ? $tr('rates.sendRequestAgain')
              : $tr('modules.sendRequest')
          }}
        </button>
        <!-- <div v-else class="send_request">{{$tr('vacancy.basic.form.modules.send_request')}}</div> -->
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'vmodules',

    props: {
      label: {
        type: String,
        default: null
      },
      type: {
        type: String, // enabled (switcher-value is item.is_enabled), enabled-by-default (switcher-value is item.is_enabled_by_default), available, all
        required: true
      },
      modules: {
        type: Array,
        required: true
      },
      is_settings_page: {
        type: Boolean,
        default: false
      },
      tooltip: {
        type: Boolean,
        default: false
      }
    },

    methods: {
      tooltip_options(v) {
        if (!this.tooltip || v) {
          return {};
        }

        return {
          content: this.$tr('modules.enableForDefaultVacancies'),
          placement: 'top-center',
          classes: 'tight center'
        };
      },
      handleInput(value, id) {
        this.$emit('toggle', { value, id });
      }
    }
  };
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.vmodules {
  max-width: 570px;

  .label {
    font-size: 15px;
    display: block;
    margin-bottom: 10px;

    &.label--settings {
      padding: 10px;
      color: rgba(33, 51, 71, 0.7);
      font-size: 15px;
      font-weight: 300;
      line-height: 40px;
    }
  }

  .vmodules_list {
    .vmodule {
      padding: 16px 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #ddd;

      &:first-child {
        border-top: 1px solid #ddd;
      }

      .vmodule_name {
        display: flex;
        align-items: center;
        // // font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        line-height: 21px;
        font-size: 15px;
        letter-spacing: 0.4px;

        .new {
          background: #437aee;
          padding: 5px;
          border-radius: 3px;
          display: block;
          color: #fff;
          margin: auto 10px;
          box-sizing: border-box;
          // // font-family: Roboto;
          font-style: normal;
          font-weight: 500;
          line-height: normal;
          font-size: 12px;
          text-align: center;
          text-transform: uppercase;
        }
      }
      .send_request {
        // // font-family: Roboto;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        font-size: 15px;
        text-align: center;
        text-transform: capitalize;
        color: $green;
        cursor: pointer;
      }
    }
  }
}
</style>
